import { RouteMatcher } from '@yl/react-router';

export const routes = {
  enrollmentRoot: new RouteMatcher('/'),
  enrollmentStep: new RouteMatcher<{ stepNumber: number }>('/step/:stepNumber')
};

export type EnrollmentRoutes = typeof routes;
